import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '../../core/client';
import { auditEndpoints } from './audit.endpoints';
import type { AuditFilters, AuditListResponse } from './audit.types';

/** Rows per audit page — the ledger's "Load N more" step. */
export const AUDIT_PAGE = 50;

/** Newest-first, keyset-paginated audit pages; refetches when filters change.
 *  `keepPreviousData` holds the current rows while a (debounced) search refetches,
 *  so typing doesn't flash the table back to a spinner. */
export function useAuditLog(filters: AuditFilters) {
  return useInfiniteQuery({
    queryKey: ['audit', filters],
    queryFn: ({ pageParam }) =>
      api.get<AuditListResponse>(auditEndpoints.list(filters, AUDIT_PAGE, pageParam || undefined)),
    initialPageParam: '',
    getNextPageParam: (last) => last.next_cursor ?? undefined,
    placeholderData: keepPreviousData,
    staleTime: 10_000,
  });
}
